var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "form", staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.cancel } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("BusinessPurchaseComponentsPur.information")) +
              " "
          ),
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
              [
                _vm._v(
                  _vm._s(_vm.$t("BusinessPurchaseComponentsPur.addingGoods"))
                ),
              ]
            ),
            _c(
              "el-button",
              {
                attrs: { disabled: _vm.selection.length === 0 },
                on: {
                  click: function ($event) {
                    return _vm.onDelete()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("delText")))]
            ),
          ],
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "bj-col bj-col-24",
          staticStyle: { "border-left": "none" },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.goodsList,
                border: "",
                script: "",
                "max-height": "600px",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "70",
                  align: "center",
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "standardSkuCode",
                  label: "SKU",
                  align: "center",
                  fixed: "left",
                  "min-width": "170",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "length", align: "center", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "red" }, [_vm._v("*")]),
                        _vm._v(" " + _vm._s(_vm.$t("goodsPage.length")) + " "),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "BjInputMoney",
                          {
                            staticClass: "full-width",
                            attrs: { min: 0, controls: false },
                            model: {
                              value: row.length,
                              callback: function ($$v) {
                                _vm.$set(row, "length", $$v)
                              },
                              expression: "row.length",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("cm")])],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "width", align: "center", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "red" }, [_vm._v("*")]),
                        _vm._v(" " + _vm._s(_vm.$t("goodsPage.width")) + " "),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "BjInputMoney",
                          {
                            staticClass: "full-width",
                            attrs: { min: 0, controls: false },
                            model: {
                              value: row.width,
                              callback: function ($$v) {
                                _vm.$set(row, "width", $$v)
                              },
                              expression: "row.width",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("cm")])],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "height", align: "center", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "red" }, [_vm._v("*")]),
                        _vm._v(" " + _vm._s(_vm.$t("goodsPage.height")) + " "),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "BjInputMoney",
                          {
                            staticClass: "full-width",
                            attrs: { min: 0, controls: false },
                            model: {
                              value: row.height,
                              callback: function ($$v) {
                                _vm.$set(row, "height", $$v)
                              },
                              expression: "row.height",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("cm")])],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "weight", align: "center", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "red" }, [_vm._v("*")]),
                        _vm._v(" " + _vm._s(_vm.$t("goodsPage.weight")) + " "),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "BjInputMoney",
                          {
                            staticClass: "full-width",
                            attrs: { min: 0, controls: false },
                            model: {
                              value: row.weight,
                              callback: function ($$v) {
                                _vm.$set(row, "weight", $$v)
                              },
                              expression: "row.weight",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("kg")])],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("table.operationText"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(row, $index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("delText")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("chooseSku", {
        ref: "chooseSkuRef",
        on: { submit: _vm.onAddDialogConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }